import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import router from './router'
import store from './store/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faHeart, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BIcon from './components/base/BIcon'
import BSearch from './components/base/BSearch'
import BShare from './components/base/BShare'

Vue.component('b-icon', BIcon)
Vue.component('b-search', BSearch)
Vue.component('b-share', BShare)

library.add(faUser)
library.add(faHeart)
library.add(faThumbsUp)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueRouter)
Vue.use(Vuex)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
